import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './nuevoStroLight.css'
export default function VerTodoDenunciaLight() {
    const id = useParams().id;
    const [denuncia, setDenuncia] = useState()
    const [cargando, setCargando] = useState(false)
    useEffect(() => {
        const fetchData = async () => {
            try {
                const resDenuncia = await axios.get(`https://back.agsseguros.online/api/verTodoEditar/${id}`);
                setDenuncia(resDenuncia.data);
                setCargando(true)
            } catch (error) {
                console.error("Error fetching data", error);
            }
        };
        fetchData();
    }, [id]);
    function formatDate(inputDate) {
        const date = new Date(inputDate);
        const day = String(date.getUTCDate()).padStart(2, "0");
        const month = String(date.getUTCMonth() + 1).padStart(2, "0");
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    }
    return (
        <>
            {cargando ?
                <div >
                    <div className="row">
                        <div className="col">
                            <label className="mb-1">Pza</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{denuncia.pza}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Pas</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{denuncia.pas}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Pas-Email</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{denuncia.email}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Codigo Productor</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{denuncia.codp}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Tipo Stro</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{denuncia.tipoStro}</div>
                        </div>
                    </div>
                    <h4 className='mt-5'>1-FECHA DEL SINIESTRO</h4>
                    <hr className='mt-3 mb-3' />
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">FECHA DENUNCIA</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{formatDate(denuncia.fechaDenuncia)}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">FECHA OCURRENCIA</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{formatDate(denuncia.fechaStro)}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">HORA DE OCURRENCIA</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{denuncia.horaStro}</div>
                        </div>
                    </div>
                    <h4 className='mt-5'>2-LUGAR DEL SINIESTRO</h4>
                    <hr className='mt-3 mb-3' />
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Calle</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionStroCalle}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Numero</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionStroNumero}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Provincia</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionStroProvincia}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Localidad</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionStroLocalidad}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">CP</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionStroCP}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Pais</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionStroPais}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">INTERSECCION DE/ ENTRE</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.interseccionStro}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Y</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.interseccionStro2}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">DETALLES DEL SINIESTRO</label>
                            <div className="burbujaModuloActualizacionStro1Light burbujaModuloActualizacionStro1Dark3">{denuncia.detallesStro}</div>
                        </div>
                    </div>
                    <h4 className='mt-5'>3- DATOS DEL CONDUCTOR DEL VEHICULO ASEGURADO</h4>
                    <hr className='mt-3 mb-3' />
                    <div>
                        <label className='mb-1 d-block'>ES EL PROPIO ASEGURADO</label>
                        <div className='burbujaModuloActualizacionStro1Light'>{denuncia.si}</div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">NOMBRE Y APELLIDO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.nombreConductorAseg}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TIPO Y N° DOCUMENTO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.dniConductorAseg}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TELEFONO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.telefonoConductorAseg}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Domicilio</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorAsegDomicilio}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">PROVINCIA</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorAsegProvincia}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Localidad</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorAsegLocalidad}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">CP</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorAsegCP}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Pais</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorAsegPais}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">REGISTRO N°</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.registroConductorAseg}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">VENCIMIENTO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{formatDate(denuncia.vencimientoConductorAseg)}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">RELACION CON EL ASEGURADO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.relacionConAseg}</div>
                        </div>
                    </div>
                    <h4 className='mt-5'>4-DATOS DEL ASEGURADO</h4>
                    <hr className='mt-3 mb-3' />
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">NOMBRE Y APELLIDO O RAZON SOCIAL</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.nombreAseg}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">TIPO Y N° DOCUMENTO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.dniAseg}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TELEFONO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.telefonoAseg}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Domicilio</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionAsegDomicilio}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">PROVINCIA</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionAsegProvincia}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Localidad</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionAsegLocalidad}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">CP</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionAsegCP}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Pais</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionAsegPais}</div>
                        </div>
                    </div>
                    <h4 className='mt-5'>5- DATOS DEL VEHICULO ASEGURADO</h4>
                    <hr className='mt-3 mb-3' />
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">MARCA Y MODELO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.marcaAseg}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TIPO:</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.tipoAseg}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">DOMINIO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.dom}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">AÑO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.anioAseg}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">N° MOTOR</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.motorAseg}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">N° CHASIS</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.chasisAseg}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">DETALLES DEL SINIESTRO</label>
                            <div className="burbujaModuloActualizacionStro1Light burbujaModuloActualizacionStro1Dark3">{denuncia.detallesDaniosAseg}</div>
                        </div>
                    </div>
                    <h4 className='mt-5'>6-DETALLE DEL OTRO VEHICULO</h4>
                    <hr className='mt-3 mb-3' />
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">PROPIETARIO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.propietarioTercero1}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TIPO Y N° DOCUMENTO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.dniTercero1}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TELEFONO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.telefonoTercero1}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Domicilio</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionTercero1Domicilio}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Provincia</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionTercero1Provincia}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Localidad</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionTercero1Localidad}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">CP</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionTercero1CP}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Pais</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionTercero1Pais}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">MARCA</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.marcaTercero1}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">MODELO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.modeloTercero1}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TIPO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.tipoTercero1}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">DOMINIO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.dominioTercero1}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">AÑO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.anioTercero1}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">NÚMERO MOTOR</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.motorTercero1}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">NÚMERO CHASIS</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.chasisTercero1}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">COMPAÑIA</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.ciaTercero1}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">NÚMERO POLIZA</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.polizaTercero1}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">DETALLES LOS DAÑOS DEL VEHICULO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.danioTercero1}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">CONDUCTOR</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.conductorTercero1}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TIPO Y N° DOCUMENTO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.dniConductorTercero1}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TELEFONO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.telefonoConductorTercero1}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Domicilio</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorTercero1Domicilio}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Localidad</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorTercero1Localidad}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Provincia</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorTercero1Provincia}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">CP</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorTercero1CP}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Pais</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorTercero1Pais}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Compañia</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.ciaConductorTercero1}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">N° POLIZA</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.polizaConductorTercero1}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">ESTADO CIVIL</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.estadoCivilConductorTercero1}</div>
                        </div>
                        <div className="col-3">
                            <label className="mb-1">FECHA NACIMIENTO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{formatDate(denuncia.fechaNacConductorTercero1)}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">CONDUCTOR HABITUAL DEL VEHICULO?</label>
                            <div className='d-flex'>
                                <input type="checkbox" checked={denuncia.si1} disabled />
                                <label className='d-block ms-2'>SI_</label>
                            </div>
                            <div className='d-flex'>
                                <input type="checkbox" checked={denuncia.no} disabled />
                                <label className=' d-block ms-2'>NO_</label>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">REGISTRO N°</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.registroTercero1}</div>
                        </div>
                        <div className="col-3">
                            <label className="mb-1">VENCIMIENTO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{formatDate(denuncia.vencimientoTercero1)}</div>
                        </div>
                    </div>
                    <h4 className='mt-5'>7- DETALLE DEL OTRO VEHICULO</h4>
                    <hr className='mt-3 mb-3' />
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">PROPIETARIO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.propietarioTercero2}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TIPO Y N° DOCUMENTO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.dniTercero2}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TELEFONO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.telefonoTercero2}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Domicilio</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionTercero2Domicilio}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Provincia</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionTercero2Provincia}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Localidad</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionTercero2Localidad}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">CP</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionTercero2CP}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Pais</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionTercero2Pais}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">MARCA</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.marcaTercero2}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">MODELO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.modeloTercero2}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TIPO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.tipoTercero2}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">DOMINIO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.dominioTercero2}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">AÑO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.anioTercero2}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">NÚMERO MOTOR</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{denuncia.motorTercero2}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">NÚMERO CHASIS</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{denuncia.chasisTercero2}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">DETALLES LOS DAÑOS DEL VEHICULO</label>
                            <textarea className="burbujaModuloActualizacionStro1Light burbujaModuloActualizacionStro1Dark3" disabled value={denuncia.detallesDanioTercero2} />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">CONDUCTOR</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{denuncia.conductorTercero2}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">TIPO Y N° DOCUMENTO</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{denuncia.dniConductorTercero2}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TELEFONO</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{denuncia.telefonoConductorTercero2}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Domicilio</label>
                            <div className="burbujaModuloActualizacionStro1Light ">{denuncia.direccionConductorTercero2Domicilio}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Provincia</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorTercero2Provincia}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Localidad</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorTercero2Localidad}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">CP</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorTercero2CP}</div>
                        </div>
                        <div className="col">
                            <label className="mb-1">Pais</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.direccionConductorTercero2Pais}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">ESTADO CIVIL</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.estadoCivilConductorTercero2}</div>
                        </div>
                        <div className="col-3">
                            <label className="mb-1">FECHA NACIMIENTO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{formatDate(denuncia.fechaNacimientoConductorTercero2)}</div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">CONDUCTOR HABITUAL DEL VEHICULO?</label>
                            <div className="burbujaModuloActualizacionStro1Light">
                                <input type="checkbox" disabled checked={denuncia.conductorHabitual} />
                                <label className="ms-2">Conductor Habitual</label>
                            </div>
                            <p>Dejar destildado en caso contrario</p>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">REGISTRO N°</label>
                            <div className="burbujaModuloActualizacionStro1Light">{denuncia.registroTercero2}</div>
                        </div>
                        <div className="col-3">
                            <label className="mb-1">VENCIMIENTO</label>
                            <div className="burbujaModuloActualizacionStro1Light">{formatDate(denuncia.vencimientoTercero2)}</div>
                        </div>
                    </div>
                    <h4 className='mt-5'>8-DAÑOS MATERIALES A COSAS</h4>
                    <hr className='mt-3 mb-3' />
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">PROPIETARIO</label>
                            <p className="burbujaModuloActualizacionStro1Light">{denuncia.propietarioMat}</p>
                        </div>
                        <div className="col">
                            <label className="mb-1">TIPO Y N° DOCUMENTO</label>
                            <p className="burbujaModuloActualizacionStro1Light">{denuncia.dniMat}</p>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">TELEFONO</label>
                            <p className="burbujaModuloActualizacionStro1Light">{denuncia.telefonoMat}</p>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Domicilio</label>
                            <p className="burbujaModuloActualizacionStro1Light">{denuncia.direccionMatDomicilio}</p>
                        </div>
                        <div className="col">
                            <label className="mb-1">Provincia</label>
                            <p className="burbujaModuloActualizacionStro1Light">{denuncia.direccionMatProvincia}</p>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Localidad</label>
                            <p className="burbujaModuloActualizacionStro1Light ">{denuncia.direccionMatLocalidad}</p>
                        </div>
                        <div className="col">
                            <label className="mb-1">CP</label>
                            <p className="burbujaModuloActualizacionStro1Light ">{denuncia.direccionMatCP}</p>
                        </div>
                        <div className="col">
                            <label className="mb-1">Pais</label>
                            <p className="burbujaModuloActualizacionStro1Light ">{denuncia.direccionMatPais}</p>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">DETALLES LOS DAÑOS DEL VEHICULO</label>
                            <p className="burbujaModuloActualizacionStro1Light burbujaModuloActualizacionStro1Dark3">{denuncia.detalleDaniosMat}</p>
                        </div>
                    </div>

                    <h4 className='mt-5'>9-LESIONES A TERCEROS</h4>
                    <hr className='mt-3 mb-3' />
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">NOMBRE Y APELLIDO</label>
                            <p className="burbujaModuloActualizacionStro1Light ">{denuncia.nombreLesTercero}</p>
                        </div>
                        <div className="col">
                            <label className="mb-1">TIPO Y N° DOCUMENTO</label>
                            <p className="burbujaModuloActualizacionStro1Light ">{denuncia.dniLesTercero}</p>
                        </div>
                        <div className="col">
                            <label className="mb-1">TELEFONO</label>
                            <p className="burbujaModuloActualizacionStro1Light ">{denuncia.telefonoLesTercero}</p>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">Domicilio</label>
                            <p className="burbujaModuloActualizacionStro1Light">{denuncia.direccionLesTerceroDomicilio}</p>
                        </div>
                        <div className="col">
                            <label className="mb-1">Provincia</label>
                            <p className="burbujaModuloActualizacionStro1Light">{denuncia.direccionLesTerceroProvincia}</p>
                        </div>
                        <div className="col">
                            <label className="mb-1">Localidad</label>
                            <p className="burbujaModuloActualizacionStro1Light">{denuncia.direccionLesTerceroLocalidad}</p>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">CP</label>
                            <p className="burbujaModuloActualizacionStro1Light">{denuncia.direccionLesTerceroCP}</p>
                        </div>
                        <div className="col">
                            <label className="mb-1">Pais</label>
                            <p className="burbujaModuloActualizacionStro1Light">{denuncia.direccionLesTerceroPais}</p>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">ESTADO CIVIL</label>
                            <p className="burbujaModuloActualizacionStro1Light">{denuncia.estadoCivilTercero}</p>
                        </div>
                        <div className="col-3">
                            <label className="mb-1">FECHA NACIMIENTO</label>
                            <p className="burbujaModuloActualizacionStro1Light">{formatDate(denuncia.fechaNacimientoLesTercero)}</p>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">RELACION CON EL ASEGURADO</label>
                            <div className="d-flex">
                                <input
                                    type="checkbox"
                                    checked={denuncia.conductorOtroVehiculo}
                                    disabled
                                />
                                <label className="d-block ms-2">CONDUCTOR OTRO VEHICULO</label>
                            </div>
                            <div className="d-flex">
                                <input
                                    type="checkbox"
                                    checked={denuncia.pasajeroVehiculoAsegurado}
                                    disabled
                                />
                                <label className="d-block ms-2">PASAJERO DE VEHICULO ASEGURADO</label>
                            </div>
                            <div className="d-flex">
                                <input
                                    type="checkbox"
                                    checked={denuncia.pasajeroOtroVehiculo}
                                    disabled
                                />
                                <label className="d-block ms-2">PASAJERO OTRO VEHICULO</label>
                            </div>
                            <div className="d-flex">
                                <input type="checkbox" checked={denuncia.peaton} disabled />
                                <label className="d-block ms-2">PEATON</label>
                            </div>
                        </div>
                        <div className="col">
                            <label className="mb-1">TIPO DE LESIONES</label>
                            <div className="d-flex">
                                <input type="checkbox" checked={denuncia.tipoLesion} disabled />
                                <label className="d-block ms-2">LEVES</label>
                            </div>
                            <div className="d-flex">
                                <input type="checkbox" checked={denuncia.tipoLesion} disabled />
                                <label className="d-block ms-2">GRAVE</label>
                            </div>
                            <div className="d-flex">
                                <input type="checkbox" checked={denuncia.tipoLesion} disabled />
                                <label className="d-block ms-2">MORTAL</label>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col">
                            <label className="mb-1">CENTRO ASISTENCIAL</label>
                            <p className="burbujaModuloActualizacionStro1Light">{denuncia.centroAsistencial}</p>
                        </div>
                    </div>
                </div> : <div className="center"><div class="spinner-border text-success center" role="status"><span class="visually-hidden center">Loading...</span></div></div>}
        </>
    );
}